import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

export const useTasks = () => {
  const pitcher = usePitcher();

  const [tasks, setTasks] = useState(() => {
    const taskList = pitcher.clients.task.getTasks();
    return taskList.tasks;
  });

  useEffect(() => {
    const disposable = pitcher.clients.task.onTaskListUpdate((taskList) =>
      setTasks(taskList.tasks),
    );
    return () => disposable.dispose();
  }, []);

  return tasks;
};
